import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LandingPage from './LandingPage';
import QuemSomosPage from './QuemSomosPage';
import PoliticaDePrivacidadePage from './PoliticaDePrivacidadePage';
import ContatoPage from './ContatoPage';
import PlanosPage from './PlanosPage';

// Páginas de Blog/Conteúdo SEO
import BlogPage from './BlogPage';
import FAQPageCompleta from './FAQPageCompleta';
import NotaFiscalMeiPage from './NotaFiscalMeiPage';
import DeclaracaoAnualMeiPage from './DeclaracaoAnualMeiPage';
import DasMei2025Page from './DasMei2025Page';
import OQueEMeiPage from './OQueEMeiPage';
import ComoAbrirMeiPage from './ComoAbrirMeiPage';
import LimiteFaturamentoMeiPage from './LimiteFaturamentoMeiPage';
import MeiInssPage from './MeiInssPage';
import NaMidiaPage from './NaMidiaPage';

// Página programática de profissões
import MeiProfissaoPage from './MeiProfissaoPage';

// Componentes de Conversão
import WhatsAppButton from './WhatsAppButton';
import ExitIntentPopup from './ExitIntentPopup';

// ✅ NOVO: Helmet Provider para meta tags dinâmicas (SEO)
import { HelmetProvider } from 'react-helmet-async';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

// App com todas as rotas
const App = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        {/* Componentes Globais de Conversão */}
        <WhatsAppButton phoneNumber="5511939614816" />
        <ExitIntentPopup />
        
        <Routes>
          {/* ==================== PÁGINAS PRINCIPAIS ==================== */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/quem-somos" element={<QuemSomosPage />} />
          <Route path="/politica-de-privacidade" element={<PoliticaDePrivacidadePage />} />
          <Route path="/contato" element={<ContatoPage />} />
          <Route path="/planos" element={<PlanosPage />} />
          
          {/* ==================== BLOG E CONTEÚDO SEO ==================== */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/faq" element={<FAQPageCompleta />} />
          
          {/* ==================== ARTIGOS PILARES (Alto Volume) ==================== */}
          <Route path="/o-que-e-mei" element={<OQueEMeiPage />} />
          <Route path="/como-abrir-mei" element={<ComoAbrirMeiPage />} />
          <Route path="/nota-fiscal-mei" element={<NotaFiscalMeiPage />} />
          <Route path="/declaracao-anual-mei" element={<DeclaracaoAnualMeiPage />} />
          <Route path="/das-mei" element={<DasMei2025Page />} />
          <Route path="/das-mei-2025" element={<DasMei2025Page />} />
          <Route path="/das-mei-2026" element={<DasMei2025Page />} />
          <Route path="/limite-faturamento-mei" element={<LimiteFaturamentoMeiPage />} />
          <Route path="/mei-inss" element={<MeiInssPage />} />
          <Route path="/mei-aposentadoria" element={<MeiInssPage />} />
          
          {/* ==================== ALIASES/REDIRECTS PARA SEO ==================== */}
          <Route path="/como-emitir-nota-fiscal-mei" element={<NotaFiscalMeiPage />} />
          <Route path="/dasn-simei" element={<DeclaracaoAnualMeiPage />} />
          <Route path="/perguntas-frequentes" element={<FAQPageCompleta />} />
          <Route path="/abrir-mei" element={<ComoAbrirMeiPage />} />
          <Route path="/abrir-mei-gratis" element={<ComoAbrirMeiPage />} />
          <Route path="/quanto-custa-mei" element={<LimiteFaturamentoMeiPage />} />
          
          {/* ==================== PÁGINA DE MÍDIA ==================== */}
          <Route path="/na-midia" element={<NaMidiaPage />} />
          <Route path="/imprensa" element={<NaMidiaPage />} />
          <Route path="/midia" element={<NaMidiaPage />} />
          
          {/* ==================== PÁGINAS PROGRAMÁTICAS POR PROFISSÃO ==================== */}
          <Route path="/mei/:profissao" element={<MeiProfissaoPage />} />
          
          {/* Variações de URL para profissões */}
          <Route path="/mei-cabeleireiro" element={<MeiProfissaoPage />} />
          <Route path="/mei-cabeleireira" element={<MeiProfissaoPage />} />
          <Route path="/mei-barbeiro" element={<MeiProfissaoPage />} />
          <Route path="/mei-manicure" element={<MeiProfissaoPage />} />
          <Route path="/mei-maquiador" element={<MeiProfissaoPage />} />
          <Route path="/mei-esteticista" element={<MeiProfissaoPage />} />
          <Route path="/mei-confeiteiro" element={<MeiProfissaoPage />} />
          <Route path="/mei-pizzaiolo" element={<MeiProfissaoPage />} />
          <Route path="/mei-eletricista" element={<MeiProfissaoPage />} />
          <Route path="/mei-encanador" element={<MeiProfissaoPage />} />
          <Route path="/mei-pedreiro" element={<MeiProfissaoPage />} />
          <Route path="/mei-pintor" element={<MeiProfissaoPage />} />
          <Route path="/mei-motorista-app" element={<MeiProfissaoPage />} />
          <Route path="/mei-motorista-de-app" element={<MeiProfissaoPage />} />
          <Route path="/mei-motoboy" element={<MeiProfissaoPage />} />
          <Route path="/mei-programador" element={<MeiProfissaoPage />} />
          <Route path="/mei-designer-grafico" element={<MeiProfissaoPage />} />
          <Route path="/mei-fotografo" element={<MeiProfissaoPage />} />
          <Route path="/mei-social-media" element={<MeiProfissaoPage />} />
          <Route path="/mei-professor-particular" element={<MeiProfissaoPage />} />
          <Route path="/mei-diarista" element={<MeiProfissaoPage />} />
          <Route path="/mei-dj" element={<MeiProfissaoPage />} />
          <Route path="/mei-decorador" element={<MeiProfissaoPage />} />
          <Route path="/mei-pet-sitter" element={<MeiProfissaoPage />} />
          <Route path="/mei-dog-walker" element={<MeiProfissaoPage />} />
          <Route path="/mei-tosador" element={<MeiProfissaoPage />} />
          
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
};

// ============================================================
// ✅ MUDANÇA PARA REACT-SNAP (PRÉ-RENDERIZAÇÃO SEO)
// ============================================================
// 
// Esta modificação permite que o react-snap pré-renderize suas páginas
// em HTML estático, fazendo com que o Google veja o conteúdo real.
//
// Como funciona:
// - Se o #root já tem conteúdo (pré-renderizado), usa hydrateRoot
// - Se está vazio (desenvolvimento), usa createRoot normal
// ============================================================

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // ✅ Página foi pré-renderizada pelo react-snap
  // Hidratar = conectar React ao HTML existente
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // 🔧 Desenvolvimento normal ou primeira renderização
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}